import {getActiveFilters, useListingFilters} from "@/utils/listing-utils.ts";
import type { Label } from "@/types/types.ts"

interface ActiveFilters {
    labelData: Label[]
}

export default function ActiveFilters({labelData}: ActiveFilters) {
    const { search, removeFilter, clearFilters } = useListingFilters();
    const activeFilters = getActiveFilters(search, labelData);

    return (
        <div className="Finder__active-filters">
            <div className="Finder__current">
                {activeFilters.map((filter) => (
                    <button type="button" key={`${filter.type}-${filter.value}`} onClick={() => removeFilter(filter.type, filter.value)} className="Finder__remove" data-name={filter.type} data-value={filter.value}>
                        {filter.label}
                    </button>
                ))}
            </div>
            <button type="button" className="Finder__reset link-cta link-cta--dark" onClick={clearFilters}>Clear Filters</button>
        </div>
    );
}